/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createParcoUser = /* GraphQL */ `
  mutation CreateParcoUser($input: CreateParcoUserInput!) {
    createParcoUser(input: $input) {
      id
      firstName
      lastName
      fullName
      email
      secondaryEmail
      phone
      address
      address2
      city
      state
      zipcode
      gender
      pickYourPath
      goalCalculateRetirementNumbers
      goalHelpInvestmentsTs
      goalAffordToRetire
      goalEarliestEligibility
      goalMaximizeFederalBenefit
      goalHelpFillingOutForms
      goalLegacyPlanning
      goalPassMoneyOn
      goalSecureIncome
      goalEstatePlanning
      dateOfBirth
      employmentStatus
      agency
      positionTitle
      dateOfHire
      retirementSystem
      retirementType
      dateOfPlannedRetirement
      baseSalary
      highThree
      currentLeaveBalance
      currentSickLeaveBalance
      plannedSickLeave
      tsp
      tspContribution
      tspContributionAmount
      tspBalance
      tspRoth
      tspRothContribution
      tspRothContributionAmount
      tspRothBalance
      tspLoans
      tspAllocation
      tspRothAllocation
      healthInsurance
      fehbCode
      fehbFivePlus
      healthInsurancePremium
      healthInsurancePremiumRetirement
      netTakeHome
      unionLocal
      unionAffiliation
      riskTolerance
      riskScore
      taxRate
      alreadyCollectingSocialSecurity
      estimatedSocialSecurity
      ageToBeginCollectingSS
      ageToBeginCollectingSSMonths
      salesforceAccountID
      salesforceLeadID
      salesforceICEventID
      retirementStrategist
      hasWill
      hasTrust
      hasFinancialAdvisor
      totalInvestableAssets
      savingsGoal
      military
      militaryBranch
      militaryServiceStartDate
      militaryServiceEndDate
      militaryReserves
      militaryReservesStartDate
      militaryReservesEndDate
      militaryActiveDutyStartDate
      militaryActiveDutyEndDate
      militaryActiveDutyPension
      militaryReservesPension
      militaryReservesPensionIncludesActiveDuty
      militaryPaidDeposit
      familyMaritalStatus
      familyDivorced
      familyDivorcedOwedPension
      familyDivorcedMarriageStartDate
      familyDivorcedMarriageEndDate
      familySpouseName
      familySpouseFirstName
      familySpouseLastName
      familySpousePhone
      familySpouseDateOfBirth
      familyChildren
      familyDependents
      fegli
      fegliBasicLife
      fegliCoverage
      fegliOptionA
      fegliOptionB
      fegliOptionBMultiples
      fegliOptionC
      fegliOptionCMultiples
      fegliNone
      fegliNotSure
      fegliExtraABL
      fegliExtraBLReduction
      fegliExtraAReduction
      fegliExtraBKeep
      fegliExtraCKeep
      lifeInsuranceOther
      privateLifeInsurance
      lifeInsuranceOtherProvider
      lifeInsuranceOtherCoverageAmount
      lifeInsuranceOtherPremium
      lifeInsuranceOtherType
      lifeInsuranceOtherAdditional
      survivorBenefitElection
      socialSecurityIntention
      survivorBenefitElectionSpouse
      rothIRA
      workFromHome
      returnToOffice
      forkSelection
      forkSelectionScenarios
      leadStatus
      accountStatus
      userNotes
      userGoals
      userTasks
      parcoScore
      retirementIncomeGap
      giftCard
      referredByEmail
      referredByName
      referredByAddress
      referralsSent
      quilttUserId
      createdAt
      updatedAt
      _version
    }
  }
`
export const updateParcoUser = /* GraphQL */ `
  mutation UpdateParcoUser(
    $input: UpdateParcoUserInput!
    $condition: ModelParcoUserConditionInput
  ) {
    updateParcoUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      fullName
      email
      secondaryEmail
      phone
      address
      address2
      city
      state
      zipcode
      gender
      pickYourPath
      goalCalculateRetirementNumbers
      goalHelpInvestmentsTs
      goalAffordToRetire
      goalEarliestEligibility
      goalMaximizeFederalBenefit
      goalHelpFillingOutForms
      goalLegacyPlanning
      goalPassMoneyOn
      goalSecureIncome
      goalEstatePlanning
      dateOfBirth
      employmentStatus
      agency
      positionTitle
      dateOfHire
      retirementSystem
      retirementType
      dateOfPlannedRetirement
      baseSalary
      highThree
      currentLeaveBalance
      currentSickLeaveBalance
      plannedSickLeave
      tsp
      tspContribution
      tspContributionAmount
      tspBalance
      tspRoth
      tspRothContribution
      tspRothContributionAmount
      tspRothBalance
      tspLoans
      tspAllocation
      tspRothAllocation
      healthInsurance
      fehbCode
      fehbFivePlus
      healthInsurancePremium
      healthInsurancePremiumRetirement
      netTakeHome
      unionLocal
      unionAffiliation
      riskTolerance
      riskScore
      taxRate
      alreadyCollectingSocialSecurity
      estimatedSocialSecurity
      ageToBeginCollectingSS
      ageToBeginCollectingSSMonths
      salesforceAccountID
      salesforceLeadID
      salesforceICEventID
      retirementStrategist
      hasWill
      hasTrust
      hasFinancialAdvisor
      totalInvestableAssets
      savingsGoal
      military
      militaryBranch
      militaryServiceStartDate
      militaryServiceEndDate
      militaryReserves
      militaryReservesStartDate
      militaryReservesEndDate
      militaryActiveDutyStartDate
      militaryActiveDutyEndDate
      militaryActiveDutyPension
      militaryReservesPension
      militaryReservesPensionIncludesActiveDuty
      militaryPaidDeposit
      familyMaritalStatus
      familyDivorced
      familyDivorcedOwedPension
      familyDivorcedMarriageStartDate
      familyDivorcedMarriageEndDate
      familySpouseName
      familySpouseFirstName
      familySpouseLastName
      familySpousePhone
      familySpouseDateOfBirth
      familyChildren
      familyDependents
      fegli
      fegliBasicLife
      fegliCoverage
      fegliOptionA
      fegliOptionB
      fegliOptionBMultiples
      fegliOptionC
      fegliOptionCMultiples
      fegliNone
      fegliNotSure
      fegliExtraABL
      fegliExtraBLReduction
      fegliExtraAReduction
      fegliExtraBKeep
      fegliExtraCKeep
      lifeInsuranceOther
      privateLifeInsurance
      lifeInsuranceOtherProvider
      lifeInsuranceOtherCoverageAmount
      lifeInsuranceOtherPremium
      lifeInsuranceOtherType
      lifeInsuranceOtherAdditional
      survivorBenefitElection
      socialSecurityIntention
      survivorBenefitElectionSpouse
      rothIRA
      workFromHome
      returnToOffice
      forkSelection
      forkSelectionScenarios
      leadStatus
      accountStatus
      userNotes
      userGoals
      userTasks
      parcoScore
      retirementIncomeGap
      giftCard
      referredByEmail
      referredByName
      referredByAddress
      referralsSent
      quilttUserId
      createdAt
      updatedAt
      _version
    }
  }
`
export const deleteParcoUser = /* GraphQL */ `
  mutation DeleteParcoUser(
    $input: DeleteParcoUserInput!
    $condition: ModelParcoUserConditionInput
  ) {
    deleteParcoUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      fullName
      email
      secondaryEmail
      phone
      address
      address2
      city
      state
      zipcode
      gender
      pickYourPath
      goalCalculateRetirementNumbers
      goalHelpInvestmentsTs
      goalAffordToRetire
      goalEarliestEligibility
      goalMaximizeFederalBenefit
      goalHelpFillingOutForms
      goalLegacyPlanning
      goalPassMoneyOn
      goalSecureIncome
      goalEstatePlanning
      dateOfBirth
      employmentStatus
      agency
      positionTitle
      dateOfHire
      retirementSystem
      retirementType
      dateOfPlannedRetirement
      baseSalary
      highThree
      currentLeaveBalance
      currentSickLeaveBalance
      plannedSickLeave
      tsp
      tspContribution
      tspContributionAmount
      tspBalance
      tspRoth
      tspRothContribution
      tspRothContributionAmount
      tspRothBalance
      tspLoans
      tspAllocation
      tspRothAllocation
      healthInsurance
      fehbCode
      fehbFivePlus
      healthInsurancePremium
      healthInsurancePremiumRetirement
      netTakeHome
      unionLocal
      unionAffiliation
      riskTolerance
      riskScore
      taxRate
      alreadyCollectingSocialSecurity
      estimatedSocialSecurity
      ageToBeginCollectingSS
      ageToBeginCollectingSSMonths
      salesforceAccountID
      salesforceLeadID
      salesforceICEventID
      retirementStrategist
      hasWill
      hasTrust
      hasFinancialAdvisor
      totalInvestableAssets
      savingsGoal
      military
      militaryBranch
      militaryServiceStartDate
      militaryServiceEndDate
      militaryReserves
      militaryReservesStartDate
      militaryReservesEndDate
      militaryActiveDutyStartDate
      militaryActiveDutyEndDate
      militaryActiveDutyPension
      militaryReservesPension
      militaryReservesPensionIncludesActiveDuty
      militaryPaidDeposit
      familyMaritalStatus
      familyDivorced
      familyDivorcedOwedPension
      familyDivorcedMarriageStartDate
      familyDivorcedMarriageEndDate
      familySpouseName
      familySpouseFirstName
      familySpouseLastName
      familySpousePhone
      familySpouseDateOfBirth
      familyChildren
      familyDependents
      fegli
      fegliBasicLife
      fegliCoverage
      fegliOptionA
      fegliOptionB
      fegliOptionBMultiples
      fegliOptionC
      fegliOptionCMultiples
      fegliNone
      fegliNotSure
      fegliExtraABL
      fegliExtraBLReduction
      fegliExtraAReduction
      fegliExtraBKeep
      fegliExtraCKeep
      lifeInsuranceOther
      privateLifeInsurance
      lifeInsuranceOtherProvider
      lifeInsuranceOtherCoverageAmount
      lifeInsuranceOtherPremium
      lifeInsuranceOtherType
      lifeInsuranceOtherAdditional
      survivorBenefitElection
      socialSecurityIntention
      survivorBenefitElectionSpouse
      rothIRA
      workFromHome
      returnToOffice
      forkSelection
      forkSelectionScenarios
      leadStatus
      accountStatus
      userNotes
      userGoals
      userTasks
      parcoScore
      retirementIncomeGap
      giftCard
      referredByEmail
      referredByName
      referredByAddress
      referralsSent
      quilttUserId
      createdAt
      updatedAt
      _version
    }
  }
`
export const updateParcoUserFamily = /* GraphQL */ `
  mutation UpdateParcoUser(
    $input: UpdateParcoUserInput!
    $condition: ModelParcoUserConditionInput
  ) {
    updateParcoUser(input: $input, condition: $condition) {
      id
      familyChildren
      familyDependents
      createdAt
      updatedAt
      _version
    }
  }
`
export const updateParcoUserGoalsTasksAndNotes = /* GraphQL */ `
  mutation UpdateParcoUser(
    $input: UpdateParcoUserInput!
    $condition: ModelParcoUserConditionInput
  ) {
    updateParcoUser(input: $input, condition: $condition) {
      id
      userNotes
      userGoals
      userTasks
      createdAt
      updatedAt
      _version
    }
  }
`
export const updateParcoUserFinances = /* GraphQL */ `
  mutation UpdateParcoUser(
    $input: UpdateParcoUserInput!
    $condition: ModelParcoUserConditionInput
  ) {
    updateParcoUser(input: $input, condition: $condition) {
      id
      riskTolerance
      riskScore
      hasFinancialAdvisor
      totalInvestableAssets
      savingsGoal
      tspAllocation
      tspRothAllocation
      createdAt
      updatedAt
      _version
    }
  }
`
export const updateParcoUserFegli = /* GraphQL */ `
  mutation UpdateParcoUser(
    $input: UpdateParcoUserInput!
    $condition: ModelParcoUserConditionInput
  ) {
    updateParcoUser(input: $input, condition: $condition) {
      id
      fegliExtraABL
      fegliExtraBLReduction
      fegliExtraAReduction
      fegliExtraBKeep
      fegliExtraCKeep
      privateLifeInsurance
      healthInsurancePremiumRetirement
      retirementType
      plannedSickLeave
      createdAt
      updatedAt
      _version
    }
  }
`
export const updateParcoUserAddress = /* GraphQL */ `
  mutation UpdateParcoUser(
    $input: UpdateParcoUserInput!
    $condition: ModelParcoUserConditionInput
  ) {
    updateParcoUser(input: $input, condition: $condition) {
      id
      address
      address2
      city
      state
      zipcode
      createdAt
      updatedAt
      _version
    }
  }
`
export const updateParcoUserSalesforce = /* GraphQL */ `
  mutation UpdateParcoUser(
    $input: UpdateParcoUserInput!
    $condition: ModelParcoUserConditionInput
  ) {
    updateParcoUser(input: $input, condition: $condition) {
      id
      salesforceAccountID
      salesforceLeadID
      salesforceICEventID
      retirementStrategist
      createdAt
      updatedAt
      _version
    }
  }
`
export const createDocument = /* GraphQL */ `
  mutation CreateDocument(
    $input: CreateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    createDocument(input: $input, condition: $condition) {
      id
      fileName
      filePath
      documentOwnerId
      uploadedByUserId
      owner
      updatedAt
      createdAt
    }
  }
`
export const makeTaskRecommendations = /* GraphQL */ `
  mutation MakeTaskRecommendations($args: String) {
    makeTaskRecommendations(args: $args) {
      id
      key
      name
      description
      link
      completedAt
    }
  }
`
